export default __webpack_public_path__ + "static/media/slide2.6d4c6375.jpeg";